export default __webpack_public_path__ + "static/media/Browsing-online-bro.dcf17048.png";